export default __webpack_public_path__ + "static/media/cover.82c6d14c.jpg";